import client from './client';
import qs from 'qs';

const projectUrl = '/api/v1/project/forecast';
const techUrl = '/api/v1/project/tech';

export const getTechProjects = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${projectUrl}/list/all?${queryString}`);
};

export const getProject = (id) => client.get(`${projectUrl}/info/${id}`);

// 프로젝트별 작업 요청 list
export const getTechsByProject = (id) => {
  return client.get(`${techUrl}/prj/${id}`);
};

// 작업 요청 리스트
export const getReqTechs = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${techUrl}/req/list?${queryString}`);
};

//작업예정리스트
export const getPlanTechs = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${techUrl}/pln/list?${queryString}`);
};

//중간보고리스트
export const getMidTechs = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${techUrl}/report/list?${queryString}`);
};

//작업완료 리스트
export const getRsltTechs = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${techUrl}/rslt/list?${queryString}`);
};

//기술지원요청 가져오기
export const getTechById = (id) => {
  return client.get(`${techUrl}/req/info/${id}`);
};

//기술지원요청리스트
export const getTechReqs = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${techUrl}/req/list?${queryString}`);
};

//기술지원요청 등록
export const addTechReq = (dataToSubmit) => {
  return client.post(`${techUrl}/req/info`, dataToSubmit);
};

//기술지원요청(예정) 수정
export const editTechReq = (dataToSubmit) => {
  return client.put(
    `${techUrl}/req/info/${dataToSubmit.reqUuid}`,
    dataToSubmit,
  );
};

//기술지원예정리스트
export const getTechPlans = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${techUrl}/pln/list?${queryString}`);
};

//기술지원 예정 가져오기(planId)
export const getTechPlanById = (id) => {
  return client.get(`${techUrl}/pln/info/${id}`);
};



//기술지원예정 등록
export const addTechPlan = (dataToSubmit) => {
  return client.post(`${techUrl}/pln/info`, dataToSubmit);
};

//기술지원예정 수정
export const editTechPlan = (dataToSubmit) => {
  return client.put(
    `${techUrl}/pln/info/${dataToSubmit.planUuid}`,
    dataToSubmit,
  );
};

//기술지원 중간보고 
export const getTechMidById = (id) => {
  return client.get(`${techUrl}/report/info/${id}`);
};

export const addTechMid = (dataToSubmit) => {
  return client.post(`${techUrl}/report/info`, dataToSubmit);
};

export const editTechMid = (id, dataToSubmit) => {
  return client.put(`${techUrl}/report/info/${id}`, dataToSubmit);
};

export const deleteTechMid = (id) => {
  return client.delete(`${techUrl}/report/info/${id}`);
};


//파일 가져오기 :fileTyp => tech, workUuid
export const getTechFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//작업 결과보고서 신규 작성
export const addRsltInfo = (dataToSubmit) => {
  return client.post(`${techUrl}/rslt/data`, dataToSubmit);
};

//작업 결과보고서 수정
export const editRsltInfo = (id, dataToSubmit) => {
  return client.put(`${techUrl}/rslt/data/${id}`, dataToSubmit);
};

//작업 결과보고서 데이터 확인
export const getRsltInfo = (id) => {
  return client.get(`${techUrl}/rslt/data/${id}`);
};

